<template>
  <div id="app-details">
    <project-head></project-head>
    <nav-bar></nav-bar>
    <el-alert title="提示：该页面为项目预览页面~" style="margin:50px 0px" type="info" close-text="知道了" v-if="$route.query.ifview"></el-alert>
    <details-top :projectData="projectData"></details-top>
    <div class="details-bottom">
      <div class="bottom-l">
        <details-nav :projectData="projectData"></details-nav>
      </div>
      <!-- <div class="bottom-r">
        <details-news :newsList="projectData.news"></details-news>
        <details-related :relateData="projectData.projects"></details-related>
      </div>-->
    </div>
    <project-foot></project-foot>
  </div>
</template>
<script>
import animate from "animate.css";
import projectHead from "../Public/head";
import navBar from "../Public/nav";
import detailsTop from "./details_top";
import detailsNav from "./details_nav";
import detailsNews from "./details_news";
import detailsRelated from "./details_related";
import projectFoot from "../Public/foot";

export default {
  components: {
    projectHead,
    navBar,
    projectFoot,
    detailsTop,
    detailsNav,
    detailsNews,
    detailsRelated
  },
  data() {
    return {
      projectData: {}
    };
  },

  mounted() {
    let loading = this.$loading({
      text: "数据正在加载中……"
    });

    let data = {};
    if (this.$route.query.ifview) {
      data.ifview = 1;
    }
    data.id = this.$route.query.id;
    this.$db.post(this.$db.config.projectDetais, data).then(res => {
      if (res && res.code == 200) {
        loading.close();
        this.projectData = res.data;
      }
    });
  },
  destroyed() {
    window.removeEventListener("scroll", this.isElementInViewport, true);
  }
};
</script>
<style lang="scss" scoped>
#app-details {
  width: 100%;
}
.details-bottom {
  width: 1300px;
  margin: 0 auto;
  padding-bottom: 65px;
  display: flex;
  justify-content: space-between;
  .bottom-l {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Project_details/details_index.vue